export default "__VITE_ASSET__B7x8Z8D9__"